<template>
  <v-dialog
    v-model="$store.state.chargeWallet"
    @update:modelValue="clear"
    :width="$store.state.desktop ? 560 : undefined"
  >
    <v-card
      class="pa-6"
    >
      <v-form @submit.prevent="charge">
        <div
          class="d-flex align-center mb-4"
        >
          <h2 class="font-weight-bold">{{ $t('charge_wallet') }}</h2>
          <v-spacer />
          <v-btn
            icon
            size="x-small"
            elevation="0"
            @click="closeDialog"
          >
            <img :src="require('@/assets/close-circle.svg')" alt="close">
          </v-btn>
        </div>

        <div class="text-N700 px-4 font-weight-medium">
          <h4>
            {{ $t('consider_instructions_during_transactions') }} 
          </h4>
          <ul class="ml-6">
            <li>{{ $t('do_not_use_vpn') }}</li>
            <li v-if="unit === '﷼'">{{ $t('maximum_amount_per_transaction_irr') }}</li>
          </ul>
        </div>

        <v-input
          hide-details
          class="text-N100 mb-1"
        >
          {{ $t('amount') }} ({{ unit }})
        </v-input>

        <vue-number
          v-model="amount"
          class="w-100 number-input"
          @keyup="get_word"
          ref="amount_input"
        ></vue-number>

        <div class="text-N100 text-end" v-if="word_price && unit === '﷼'">
          {{ word_price }}
        </div>

        <div
          class="d-flex justify-end mt-4"
        >
          <v-btn
            variant="text"
            color="primary"
            class="me-3 text-capitalize"
            @click="closeDialog"
            :disabled="loading"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            class="text-capitalize"
            type="submit"
            :loading="loading"
            :disabled="loading"
          >
            {{ $t('continue') }}
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { component as VueNumber } from '@coders-tm/vue-number-format'
import CustomInput from '@/components/CustomInput.vue'
import api from "@/api";
import { wordifyRialsInTomans } from '@/modules/wordifyfa/wordifyfa'

export default {
  name: 'ChargeWallet',
  components: {
    CustomInput,
    VueNumber
  },
  data: () => ({
    amount: '',
    loading: false,
    word_price: ''
  }),
  props: ['unit', 'user_info'],
  watch: {
    amount(value) {
      this.word_price = wordifyRialsInTomans(value)
    }
  },
  methods: {
    charge() {
      if (this.amount && !isNaN(this.amount) && this.user_info.country_code === '+98') {
        this.loading = true
        api.charge_wallet(this.amount).then(res => {
          this.loading = false
          if (res.data.id) {
            let link_payment = document.createElement('a')
            link_payment.href = res.data.link
            link_payment.click()
          } else {
            this.$store.state.textAlert = res.data.error_message
            this.$store.state.typeAlert = "warning"
            this.$store.state.alert = true
          }
        }).catch(() => {
          this.loading = false
        })
      } else if (this.user_info.country_code !== '+98') {
        this.$store.state.textAlert = this.$t('payment_gateway_coming_soon')
        this.$store.state.typeAlert = "warning"
        this.$store.state.alert = true
      } else {
        this.$store.state.textAlert = this.$t('enter_charge_amount_correctly')
        this.$store.state.typeAlert = "warning"
        this.$store.state.alert = true
      }
    },
    clear() {
      this.amount = ''
    },
    closeDialog() {
      this.$store.state.chargeWallet = false
      this.clear()
    },
    with_currency(amount) {
      return new Intl.NumberFormat(navigator.language, { style: 'currency', currency: "USD" }).formatToParts(amount).map(val => val.value).join('');
    },
    get_word() {
      this.word_price = wordifyRialsInTomans(this.$refs.amount_input.unmaskedValue)
    }
  }
}
</script>

<style>
.number-input {
  height: 40px;
  padding: 0 16px;
  border: 1px solid #aaa;
  border-radius: 4px;
  outline: none;
}

.number-input:focus {
  border: 2px solid black;
}
</style>
